import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { DatePipe } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../core/reducers';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from 'src/app/core/auth/_services';
import { StringUtilsService } from '../../../../core/services/string-utils.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ContactsService } from '../../../../core/lists';
import { GeneralAutocompleteComponent } from '../../../partials/layout/general-autocomplete/general-autocomplete.component';
import { clone } from 'lodash-es';
import { FollowUpService } from '../../../../core/services/follow-up.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'kt-new-attempt-dialog',
  templateUrl: './new-attempt-dialog.component.html',
  styleUrls: ['./new-attempt-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewAttemptDialogComponent implements OnInit, OnDestroy {
  contactAutocompleteCall = this.contactsService.searchContactsFollowups.bind(
    this.contactsService,
    this.data.relatedIds,
  );
  @ViewChild('followupContactAutocomplete')
  followupContactAutocomplete: GeneralAutocompleteComponent;
  reasonAutocompleteCall = this.followUpService.searchReasons.bind(this.followUpService);
  @ViewChild('reasonAutocomplete') reasonAutocomplete: GeneralAutocompleteComponent;
  attemptForm: FormGroup;
  hasFormErrors: boolean;
  followUp;
  comments = [];
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<NewAttemptDialogComponent>,
    private userService: UserService,
    private store: Store<AppState>,
    private translate: TranslateService,
    private cdr: ChangeDetectorRef,
    public dialog: MatDialog,
    public datePipe: DatePipe,
    private fb: FormBuilder,
    private contactsService: ContactsService,
    private followUpService: FollowUpService,
    public stringUtils: StringUtilsService,
  ) {}
  ngOnInit() {
    this.createForm();
    // if(this.data.comments && this.data.comments.length>0){
    //   this.comments = this.data.comments
    //   this.cdr.detectChanges()
    // }
  }
  createForm() {
    this.attemptForm = this.fb.group({
      reason: [],
      followupContact: [],
      followupDate: [],
      attempt_comment: [],
    });
    setTimeout(() => {
      this.fillData();
    });
  }
  fillData() {
    if (this.data.followupDate) {
      this.attemptForm.controls.followupDate.setValue(this.data.followupDate);
    }
    if (this.data.followupContact) {
      this.attemptForm.controls.followupContact.setValue(this.data.followupContact);
      this.followupContactAutocomplete.setValue(this.data.followupContact);
    }
  }
  getTitle() {
    return 'New Attempt';
  }
  ngOnDestroy() {
    this.cdr.detach();
  }
  close() {
    this.dialogRef.close();
  }
  onContactChange(val) {
    this.attemptForm.controls.followupContact.setValue(val);
    this.attemptForm.controls.followupContact.updateValueAndValidity();
  }
  onReasonChange(val) {
    this.attemptForm.controls.reason.setValue(val);
    this.attemptForm.controls.reason.updateValueAndValidity();
  }
  onSubmit() {
    this.hasFormErrors = false;
    const controls = this.attemptForm.controls;
    this.followupContactAutocomplete.updateValueAndValidity();
    /** check form */
    if (this.attemptForm.invalid) {
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
      this.hasFormErrors = true;
      return;
    }
    this.dialogRef.close({
      attempt: clone(this.attemptForm.value),
      attempts_count: this.data.attempt_count + 1,
      reason: this.attemptForm.controls.reason.value,
      fromAttempt: true,
    });
  }
}
